<template>
  <div>
    <v-layout class="wrapper">
      <transition name="slide">
        <v-flex xs12 class="bar" v-if="visible">
          <v-toolbar color="earth">
            <slot />
          </v-toolbar>
        </v-flex>
      </transition>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'BottomActionsBar',
  props: {
    visible: Boolean,
  },
}
</script>

<style scoped>
.wrapper {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.bar {
  overflow-y: auto;
  transition: transform 1000ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.slide-enter-active {
  transform: translateY(0);
}

.slide-enter,
.slide-leave-to {
  transform: translateY(300px);
}
</style>
